import { createCrystallizeClient } from "@workspace/crystallize";
import type { ContentChunksComponentForNavigationNavigationMenus } from "@workspace/crystallize/generated/discovery/";
import { Outlet } from "react-router";
import { CartProvider } from "~/components/cart/cart-provider";
import Footer from "~/components/footer";
import Header from "~/components/header";
import type { Route } from "./+types/layout";

type NavMenu = ContentChunksComponentForNavigationNavigationMenus;

export const loader = async ({ request, context }: Route.LoaderArgs) => {
	try {
		const {
			cloudflare: { env, cacheTags },
		} = context;

		const url = new URL(request.url);
		const previewMode = url.searchParams.get("preview") === "true";

		cacheTags.add("crystallize:navigation");

		const Crystallize = createCrystallizeClient({
			discovery: {
				tenantIdentifier: env.CRYSTALLIZE_TENANT_IDENTIFIER,
			},
		});

		const {
			browse: {
				navigation: {
					hits: [{ navigationMenus }],
				},
			},
		} = await Crystallize.discovery.navigation(previewMode);

		// Normalize "/" paths so aliases that include "/" resolve to "/"
		for (const menu of navigationMenus) {
			for (const item of menu.links.items) {
				if (item.aliases.includes("/")) {
					item.path = "/";
				}
			}
		}

		return {
			main: navigationMenus.find((m: NavMenu) => m.name === "hovedmeny"),
			footer: navigationMenus.find((m: NavMenu) => m.name === "footermeny"),
		};
	} catch (error) {
		console.error("Error fetching navigation data:", error);
		throw new Response("Failed to load navigation data", { status: 500 });
	}
};

export default function Layout({ loaderData }: Route.ComponentProps) {
	const { main, footer } = loaderData;
	return (
		<CartProvider>
			<div className="flex min-h-screen flex-col">
				<Header items={main?.links?.items} />
				<main className="grow">
					<Outlet />
				</main>
				<Footer menuItems={footer?.links?.items} />
			</div>
		</CartProvider>
	);
}
